export const landingTranslations = {
  en: {
    hero: {
      title: '🌟 AI Learning Platform for Middle School Students',
      subtitle: 'Learn Math & English smarter with AI — get personalized analysis and learning path recommendations.',
      startLearning: 'Start Learning',
      learnMore: 'Learn More'
    },
    features: {
      title: 'Key Features',
      subtitle: 'AI makes learning engaging, effective, and personalized to your abilities.',
      cards: [
        {
          title: 'Personalized Learning',
          desc: 'AI tracks results and recommends content tailored to each student.'
        },
        {
          title: 'AI Feedback',
          desc: 'Analyzes strengths and weaknesses, suggests effective 3-day study plans.'
        },
        {
          title: 'Fun Exercises',
          desc: 'Engaging quizzes with visual progress tracking through charts.'
        }
      ]
    },
    cta: {
      title: 'Start your smart learning journey with AI',
      subtitle: 'Just a few minutes daily to enhance your knowledge and learning skills!',
      button: 'Start Now'
    }
  },
  vi: {
    hero: {
      title: '🌟 Nền tảng học tập AI cho học sinh THCS',
      subtitle: 'Học Toán & Tiếng Anh thông minh hơn với AI — hệ thống phân tích kết quả và gợi ý lộ trình cá nhân hóa.',
      startLearning: 'Bắt đầu học',
      learnMore: 'Tìm hiểu thêm'
    },
    features: {
      title: 'Tính năng nổi bật',
      subtitle: 'Ứng dụng AI giúp việc học trở nên thú vị, hiệu quả và phù hợp năng lực riêng.',
      cards: [
        {
          title: 'Học tập cá nhân hóa',
          desc: 'AI theo dõi kết quả, đề xuất nội dung phù hợp với từng học sinh.'
        },
        {
          title: 'Phản hồi từ AI',
          desc: 'Phân tích điểm mạnh - yếu, gợi ý kế hoạch học 3 ngày hiệu quả.'
        },
        {
          title: 'Bài luyện thú vị',
          desc: 'Làm bài trắc nghiệm vui nhộn, xem tiến bộ bằng biểu đồ trực quan.'
        }
      ]
    },
    cta: {
      title: 'Bắt đầu hành trình học tập thông minh với AI',
      subtitle: 'Chỉ vài phút mỗi ngày để nâng cao kiến thức và kỹ năng học tập!',
      button: 'Học ngay'
    }
  }
};